import met from '@viatsyshyn/ts-simple-query';
import * as teeth from '../teeth-range';

function revolverFor(formValues, itemNums, account) {
  return (ref, condition) => {
    if (ref === '$itemnum') {
      return itemNums && ((Array.isArray(itemNums) ? itemNums.indexOf(condition) >= 0 : itemNums[condition]));
    }

    if (ref === '$teeth:contains') {
      const [key] = Object.keys(condition);
      const range = condition[key];
      const selections = formValues[key];
      if (selections == null) {
        return false;
      }
      const obj = JSON.parse(selections);
      const selected = teeth.merge(...Object.keys(obj));
      return teeth.intersect(selected, range).length > 0;
    }

    if (ref.startsWith('$')) {
      throw new Error(`Unknown operator ${ref}`);
    }

    if (ref.startsWith('@account.extdata')) {
      return account.extdata[ref.substr(16)];
    }

    if (ref.startsWith('@account.')) {
      return account[ref.substr(9)];
    }

    const props = ref.split('.') || [];
    if (props.length > 1) {
      let res = formValues[props[0]];
      if (res) {
        for (let i = 1; i < props.length; i++) {
          res = res[props[i]];
          if (!res) {
            return null;
          }
        }
        return res;
      }
    }
    return formValues[ref];
  }
}

export default {
  computed: {
    productFilter() {
      let parent = this.$parent;
      while (parent && !parent.getProductFilters) {
        parent = parent.$parent;
      }
      return parent ? parent.getProductFilters() : [];
    }
  },
  methods: {
    fieldType(field) {
      if (typeof field.type !== 'undefined') {
        return field.type;
      }
      if (typeof field.options !== 'undefined') {
        return 'select';
      }

      return 'switch';
    },
    meetsRequirements(field) {
      if (field.requires != null) {
        const itemNums = this.itemNumsAll || this.itemNums || {};
        return met(field.requires, revolverFor(this.formValues, itemNums, this.$root.currentUser));
      }

      return !(typeof field.itemnum !== 'undefined' && this.productFilter.indexOf(field.itemnum) > -1);
    },
    updateFormInput(value, field) {
      this.formValues[field.name] = value;
      this.$forceUpdate();
    }
  }
}
